import { render, staticRenderFns } from "./LegSummary.vue?vue&type=template&id=10f648a6&"
import script from "./LegSummary.vue?vue&type=script&lang=js&"
export * from "./LegSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports